import styled from '@emotion/styled';
import { Button, Title } from 'components';

export const MargedTitle = styled(Title)`
    margin-bottom: ${({ theme }) => theme.base.spacing[3]};
`;

export const MargedButton = styled(Button)`
    margin-top: ${({ theme }) => theme.base.spacing[7]};
`;
